import styled from "styled-components";
import { token } from "@atlaskit/tokens";
import { N0, N900, B400, N50A } from "@atlaskit/theme/colors";
import { Breakpoint } from "../../Shared/consts";

export const CartProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 18px;
  padding-left: 5px;
  padding-right: 5px;
`;

export const AdditionalInformation = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 5px;
  padding-right: 25px;
`;

export const Wrapper = styled.div`
  padding: 16px 20px;
  box-shadow: ${token(
    "elevation.shadow.raised",
    "0px 1px 1px rgba(9, 30, 66, 0.25),0px 0px 1px rgba(9, 30, 66, 0.31)"
  )};
  border-radius: 3px;
  background-color: ${token("elevation.surface.raised", N0)};
  transition: box-shadow 100ms linear;

  &:hover {
    box-shadow: ${token(
      "elevation.shadow.overlay",
      "0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31)"
    )};
  }
`;

export const MainRow = styled.div`
  display: flex;
  column-gap: 20px;
  flex-direction: row;
  justify-content: space-between;
`;

export const MainRowSection = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  align-items: center;
  @media screen and ${Breakpoint.mobile} {
    columng-gap: 0px;
  }
`;

export const ProductInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const CountNameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  row-gap: 8px;
  column-gap: 8px;
  align-items: center;
  @media screen and ${Breakpoint.mobile} {
    flex-direction: column;
    align-items: start;
  }
`;

export const Image = styled.div`
  width: 106px;
  height: 106px;
  background: ${({ imageSrc }) => `url("${imageSrc}")`} no-repeat center;
  background-size: contain;
  border-radius: 3px;
`;

export const NoImageWrapper = styled.div`
  width: 106px;
  height: 106px;
  display: grid;
  place-content: flex-start center;
`;

export const Price = styled.div`
  color: ${token("color.text.accent.blue", B400)};
  font-size: 20px;
  font-weight: 500;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Name = styled.span`
  color: ${token("color.text", N900)};
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
`;

export const Divider = styled.div`
  border-top: 1px solid ${token("color.border", N50A)};
  opacity: ${({ isShowing }) => (isShowing ? "1" : "0")};
  margin-top: ${({ isShowing }) => (isShowing ? "8px" : "0px")};
  margin-bottom: ${({ isShowing }) => (isShowing ? "16px" : "0px")};
  transition: all 500ms ease;
`;

export const Description = styled.div`
  max-height: 125px;
  overflow-y: auto;

  color: var(--ds-text, #172b4d);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  ::-webkit-scrollbar {
    display: none;
  }

  & {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

export const ProductDetailsWrapper = styled.div`
  width: 100%;
  max-height: ${({ isExpanded }) => (isExpanded ? "700px" : "0px")};
  overflow-y: auto;
  transition: all 500ms ease;
`;

export const ProductDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const DetailsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 32px;
  row-gap: 16px;
`;

export const DetailWrapper = styled.div`
  display: grid;
  grid-template-columns: 135px auto;
  align-items: center;
  column-gap: 8px;
`;

export const DetailLabel = styled.span`
  color: var(--ds-text-subtle);
  font-size: var(--ds-space-150, 12px);
  font-weight: 600;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const DetailValue = styled.span`
  color: var(--ds-text);
  font-size: 14px;
  font-weight: 400;
  width: fit-content;
  max-width: 100%;

  max-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  ${({ type }) => {
    if (type === "Textarea") return "white-space: pre-wrap; width: 100%;";
    return "";
  }}
`;

export const Total = styled.span`
  font-size: 20px;
  font-weight: 500;
  line-height: 24x;
`;

export const TotalPrice = styled.span`
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  color: ${token("color.text.accent.blue", B400)};
`;

export const PanelWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ShopTitle = styled.div`
  color: ${token("color.text", N900)};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
